export const IndexRoutes = [
  {
    path: '/',
    alias: ['/:preview?'],
    name: 'Index',
    component:  () => {
      return import('@pages/standard-list/index.vue')
    },
    props: {
      pageTitle: '诺诺自营区',
      shareTitle: '诺诺自营区｜爱车的诺诺',
    },
    meta: {
      title: '首页',
    },
  },
]
